/**
 * The active tenant configuration, loaded once from the object Vite inlined at build time
 * (see vite.config.ts `define.__TENANT__`, sourced from config/tenant.json) and validated by
 * `@birflypermit/shared`'s `loadTenant`.
 */
import { loadTenant } from '@birflypermit/shared/tenant';

export const tenant = loadTenant(__TENANT__);
